import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.7071 1.29289C17.0976 1.68342 17.0976 2.31658 16.7071 2.70711L7.41421 12L16.7071 21.2929C17.0976 21.6834 17.0976 22.3166 16.7071 22.7071C16.3166 23.0976 15.6834 23.0976 15.2929 22.7071L5.29289 12.7071C4.90237 12.3166 4.90237 11.6834 5.29289 11.2929L15.2929 1.29289C15.6834 0.902369 16.3166 0.902369 16.7071 1.29289Z"
  }));
});
var NavigationChevronLeft = AbstractIcon.withComponent(Icon);
NavigationChevronLeft.displayName = 'NavigationChevronLeft';
export default NavigationChevronLeft;